<div class="header">
  {{'' | i18n: 'model-group-pricing'}}.
</div>
<div class="wrapper">
  <div class="item">{{''|i18n:'period'}}:</div>
  <div class="item">{{''|i18n:'make'}}:</div>
</div>
<div class="wrapper">
  <select class="item" [(ngModel)]="selectedPeriod" (change)="onYearSelected()">
    <option [value]="null">{{''| i18n:'select'}}</option>
    @for (period of periods; track period) {
      <option [ngValue]="period">{{period}}</option>
    }
  </select>
  <select [(ngModel)]="selectedBrand" (change)="onBrandSelected()">
    @for (brand of brands; track brand) {
      <option [ngValue]="brand">{{brand.name}}</option>
    }
  </select>
</div>

<div class="header-content">
  <div class="price-matrix-header">{{''| i18n:'model-group'}}</div>
  @for (item of headers; track item) {
    <div class="price-matrix-header">
      <span>{{''| i18n:'up-to'}}&nbsp;</span>
      <span>{{getAgeInYears(item.ageMileageConfiguration.age)}}&nbsp;</span>
      <span>{{''| i18n:'year-and-max'}}&nbsp;</span>
      <span>{{(item.ageMileageConfiguration?.kilometrage)}}</span>
      <span> km</span>
      <span> ({{item.ageMileageConfiguration.category}})</span>
    </div>
  }
</div>

@for (price of matrix; track price) {
  <div class="pricing-table-list">
    <div>{{price.modelGroup.description}}</div>
    @for (m of price.pricingMatrices; track m) {
      <div>
        <input type="number" [(ngModel)]="m.amount">
      </div>
    }
  </div>
}
<div class="button-spacer">
  <button class="button button-white" (click)="update()">{{'' | i18n: 'save'}}</button>
</div>




